$(document).ready(function () {
    $('.faq-question').click(function () {
        $(this).next('.faq-answer').slideToggle();
        $(this).parent('.faq-item').toggleClass('faq-item-opened');
    });

    // toggle :before from - to +
    $('.faq-item').first().addClass('faq-item-opened');
    // open first item
    $('.faq-answer').first().css('display', '');
});